import React, { useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { courseStateNames } from "./components/courseState";
import { getCourses } from "../../queries/courses";
import { TextFilter } from "../../components/Overview/Filters/TextFilter";
import { DropDownFilter } from "../../components/Overview/Filters/DropdownFilter";
import ReactTooltip from "react-tooltip";
// import Filter from "../../components/Filter";
// import {Tooltip} from "../../components/Tooltip";
import { generatePath } from "react-router-dom";
// import {browserHistory} from "react-router"; // v3 style for navigate() in v5/v6rc1
import cx from "classnames";
import { AutocompleteFilter } from "../../components/Overview/Filters/AutocompleteFilter";
// import {DateFilterFromTill} from "../../components/Overview/Filters/DateFilterFromTill";
import { IconTitle } from "../../components/Overview/Titles/IconTitle";
import { StatusTitle } from "../../components/Overview/Titles/StatusTitle";
import * as constants from "../../constants";

// Provide a function which returns a HTML structure based on the row-information from the overview
export const RowStructure = (props) => {
    const eventCount = props.events?.length || props.events;
    const studentCount = props.students?.length || props.students;
    const now = moment();

    const needsAttentionTest = props.state === constants.COURSE_STATE_ENDED && props.end_datetime && moment(now).diff(props.end_datetime, "hours") > 48;

    const missingInfo = (() => {
        if (props?.contextData?.missingInfo > 0) {
            return "Deze cursus mist informatie. Bekijk de cursusdetails voor details.";
        }
    })();

    const needsAttention = (() => {
        if (needsAttentionTest) {
            return "Deze cursus is meer dan 48 uur geleden afgelopen maar is nog steeds niet afgerond.";
        }
        return false;
    })();

    const detailPathRoute = needsAttentionTest ? "/details" : "/students";

    const detailPath = generatePath("/courses/edit/:uuid" + (eventCount === 0 ? "" : detailPathRoute), {
        uuid: props.uuid
    });

    const detailClick = (e) => {
        // browserHistory.push(detailPath);
        window.open(detailPath);
    };

    // it is loosely based on what was already there in overview.js
    return (
        <tr key={props.id}>
            {props.columns.some((col) => col.columnIdentifier === "id") && (
                <td onClick={detailClick}>
                    <div className={"overview-redux__truncated-text"} title={props.id}>
                        {props.id}
                    </div>
                </td>
            )}

            <td onClick={detailClick}>
                <div className={"overview-redux__truncated-text"}>
                    {eventCount === 0 || !props.course_datetime?.start_datetime ? <>N.N.B.</> : <>{moment(props.course_datetime.start_datetime).format("DD-MM-YYYY")}</>}
                </div>
            </td>

            {props.columns.some((col) => col.columnIdentifier === "your_reference") && (
                <td onClick={detailClick}>
                    <div className={"overview-redux__truncated-text"} title={props.your_reference}>
                        {props.your_reference}
                    </div>

                    {props?.messages &&
                        props.messages.map((m, idx) => (
                            <div key={idx} className={cx("overview-redux__error-message")}>
                                {m.message}
                            </div>
                        ))}
                </td>
            )}

            {props.columns.some((col) => col.columnIdentifier === "display_name") && (
                <td onClick={detailClick}>
                    <div className={"overview-redux__truncated-text"} title={props.display_name}>
                        {props.display_name}
                    </div>
                </td>
            )}

            {props.columns.some((col) => col.columnIdentifier === "trainer") && (
                <td onClick={detailClick}>
                    <div className={"overview-redux__truncated-text"} title={props.trainer_details?.name}>
                        {props.trainer_details?.name}
                    </div>
                </td>
            )}

            {/*{props.columns.some(col => col.columnIdentifier === "account_manager") && (*/}
            {/*    <td onClick={detailClick}>*/}
            {/*        {props.account_manager?.full_name}*/}
            {/*    </td>*/}
            {/*)}*/}

            {/*{props.columns.some(col => col.columnIdentifier === "instructor") && (*/}
            {/*    <td onClick={detailClick}>*/}
            {/*        {props.instructor?.full_name}*/}
            {/*    </td>*/}
            {/*)}*/}

            <td onClick={detailClick}>
                <span
                    className={"course-status-indicator course-status-indicator--mini course-status-indicator--" + props.state}
                    title={courseStateNames?.find((item) => item.slug === props.state)?.name}
                />
            </td>

            <td onClick={detailClick}>
                <div className={"overview-redux__truncated-text"}>
                    <div className="courses-persons">
                        {studentCount} / {props.expected_students}
                    </div>
                </div>
            </td>
            <td onClick={detailClick}>
                {missingInfo && (
                    <>
                        <i className="fa fa-exclamation-triangle overview-redux__attention-icon" data-tip data-for={`attention-${props.id}`} />
                        <ReactTooltip id={`attention-${props.id}`} effect="solid" place="bottom">
                            {missingInfo}
                        </ReactTooltip>
                    </>
                )}

                {needsAttention && (
                    <>
                        <i className="fa fa-exclamation-triangle overview-redux__attention-icon" data-tip data-for={`attention-${props.id}`} />
                        <ReactTooltip id={`attention-${props.id}`} effect="solid" place="bottom">
                            {needsAttention}
                        </ReactTooltip>
                    </>
                )}
            </td>
        </tr>
    );
};

// Define how this particular type of overview works
export const CoursesOverviewDefinitionBase = {
    queryFn: getCourses,
    RowStructure,
    search: {
        // columnIdentifier: "search",
        // placeholder: "Zoek op naam, contactpersoon, opleider, competentieprofiel of cursus-id"
    },
    columns: [
        {
            title: "id",
            columnIdentifier: "id",
            placeholder: "#",
            orderable: true,
            Filter: TextFilter
        },
        {
            title: "Datum",
            columnIdentifier: "date",
            orderable: true,
            placeholder: "Datum",
            Filter: (props) => {
                const [selectedDate, setSelectedDate] = useState(null);

                return (
                    <DatePicker
                        selected={selectedDate}
                        onChange={(date) => {
                            setSelectedDate(date);

                            const formattedDate = date ? moment(date).format("YYYY-MM-DD") : "";
                            props.setFilter("start_date_exact", formattedDate);
                        }}
                        className={cx("text-filter", props.className)}
                        style={{ height: "36px" }}
                        dateFormat="DD-MM-YYYY"
                    />
                );
            }
        },
        {
            title: "Referentie",
            columnIdentifier: "your_reference",
            orderable: true,
            Filter: TextFilter,
            placeholder: "Cursusreferentie",
            Skeleton: (props) => {
                // Example for a Skeleton item in column definition
                return (
                    <div className={"table-skeleton"}>
                        <div className="courses-title">&nbsp;</div>
                    </div>
                );
            }
        },
        {
            title: "Cursusnaam",
            columnIdentifier: "display_name",
            placeholder: "Cursusnaam",
            orderable: true,
            Filter: TextFilter
        },
        {
            title: "Opleider",
            columnIdentifier: "trainer",
            orderable: false,
            Filter: AutocompleteFilter,
            FilterOptions: {
                contextIdentifier: "trainers",
                filterIdentifier: "trainer",
                className: "table-head-dropdown"
            },
            placeholder: "Naam van de opleider"
        },
        // {
        //     title: "Acc Mgr",
        //     columnIdentifier: "account_manager",
        //     orderable: true,
        //     Filter: AutocompleteFilter,
        //     FilterOptions: {
        //         contextIdentifier: "account_managers",
        //     },
        //     placeholder: "Naam van de accountmanager"
        // },
        // {
        //     title: "Instructeur",
        //     columnIdentifier: "instructor",
        //     orderable: true,
        //     Filter: AutocompleteFilter,
        //     FilterOptions: {
        //         contextIdentifier: "instructors",
        //     },
        //     placeholder: "Naam van de instructeur"
        // },
        {
            title: "Status",
            Title: StatusTitle,
            columnIdentifier: "state",
            Filter: DropDownFilter, // Disabled as we have it in the sidebar
            FilterOptions: {
                options: courseStateNames
            }
        },
        {
            // title: "Deelnemers",
            columnIdentifier: "participants",
            Title: IconTitle,
            TitleOptions: {
                icon: "user"
            }
        },
        {
            // title: "Deelnemers",
            columnIdentifier: "errors"
        }
    ],
    // topbar: [
    //     // {
    //     //     columnIdentifier: "state",
    //     //     type: "filter",
    //     //     Component: (props) => {
    //     //         return (
    //     //             <>
    //     //                 <div className="filter-block">
    //     //
    //     //                     <h2>
    //     //                         Status<Tooltip tooltip={<CourseStateTooltip />}/>
    //     //                     </h2>
    //     //                     {Object.entries(courseStateNames).map(([value, name]) => ({value, name})).map(item => {
    //     //                         const state = props.filterState?.[props.columnIdentifier] || [];
    //     //                         return (
    //     //                             <Fragment key={item.name}>
    //     //                                 <label htmlFor={item.name} className={cx("filter-item-checkbox", {"active": state?.includes(item.value) === true})}>
    //     //                                     <input
    //     //                                         type="checkbox"
    //     //                                         id={item.name}
    //     //                                         name={item.name}
    //     //                                         value={item.value}
    //     //                                         checked={state?.includes(item.value) === true}
    //     //                                         onChange={(e) => {
    //     //                                             let newOpts = e.target.checked ? !state?.includes(e.target.value) ? [...state, item.value] : [...state] : state.filter(o => o !== item.value);
    //     //                                             props.setFilter(props.columnIdentifier, newOpts);
    //     //                                         }}
    //     //                                     />
    //     //                                     {item.name}
    //     //                                 </label>
    //     //                             </Fragment>
    //     //                         );
    //     //                     })}
    //     //                 </div>
    //     //             </>
    //     //         );
    //     //     }
    //     // },
    //     // {
    //     //     columnIdentifier: "trainer",
    //     //     type: "filter",
    //     //     Component: props => {
    //     //         return (
    //     //             <Filter
    //     //                 title="Opleider"
    //     //                 type="dropdown"
    //     //                 compatibility={"new"}
    //     //                 filterName="trainer"
    //     //                 filters={props.contextData?.trainers}
    //     //                 handleFilter={(name, value) => props.setFilter(name, value || "")}
    //     //                 activeFilters={props.filterState || {}}
    //     //             />
    //     //         );
    //     //     }
    //     // },
    //     {
    //         columnIdentifier: "account_manager",
    //         Component: props => {
    //             return (
    //                 <>
    //                     <span>NIBHV Contactpersoon</span>
    //                     <Filter
    //                         filterName={props.columnIdentifier}
    //                         filters={props.contextData?.account_managers || []}
    //                         noTitle={true}
    //                         key={props.columnIdentifier}
    //                         // className={cx("text-filter", props.className)}
    //                         type="dropdown"
    //                         compatibility={"new"}
    //                         placeholder={"Naam van de accountmanager"}
    //                         handleFilter={ (name, value) => props.setFilter(name, value || "") }
    //                         activeFilters={props.filterState || {}}
    //                         onChange={(e) => props.setFilter(props.columnIdentifier, e.target.value)}
    //                     />
    //
    //                 </>
    //             );
    //         }
    //     },
    //     {
    //         title: "Instructeur",
    //         columnIdentifier: "instructor",
    //         orderable: true,
    //         Component: props => {
    //             return (
    //                 <>
    //                     <span>Instructeur</span>
    //                     <Filter
    //                         noTitle={true}
    //                         filterName={props.columnIdentifier}
    //                         filters={props.contextData?.instructors || []}
    //                         key={props.columnIdentifier}
    //                         // className={cx("text-filter", props.className)}
    //                         type="dropdown"
    //                         compatibility={"new"}
    //                         placeholder={"Naam van de instructeur"}
    //                         handleFilter={ (name, value) => props.setFilter(name, value || "") }
    //                         activeFilters={props.filterState || {}}
    //                         onChange={(e) => props.setFilter(props.columnIdentifier, e.target.value)}
    //                     />
    //                 </>
    //             );
    //         },
    //     },
    //     {
    //         columnIdentifier: "start_datetime_after",
    //         type: "filter",
    //         Component: (props) => {
    //             return (
    //                 <>
    //                     <span>Datum vanaf</span>
    //                     <Filter
    //                         noTitle={true}
    //                         type="date"
    //                         compatibility={"new"}
    //                         filterName={props.columnIdentifier}
    //                         filters={[]}
    //                         handleFilter={ (name, value) => props.setFilter(name, value || "") }
    //                         activeFilters={props.filterState || {}}
    //                     />
    //                 </>
    //             );
    //         }
    //     },
    //     {
    //         columnIdentifier: "start_datetime_before",
    //         type: "filter",
    //         Component: (props) => {
    //             return (
    //                 <>
    //                     <span>Datum tot</span>
    //                     <Filter
    //                         noTitle={true}
    //                         type="date"
    //                         compatibility={"new"}
    //                         filterName={props.columnIdentifier}
    //                         filters={[]}
    //                         handleFilter={ (name, value) => props.setFilter(name, value || "") }
    //                         activeFilters={props.filterState || {}}
    //                     />
    //                 </>
    //             );
    //         }
    //     },
    //     {
    //         columnIdentifier: "student__first_name",
    //         type: "filter",
    //         Component: (props) => {
    //             return (
    //                 <>
    //                     <span>Cursist: voornaam</span>
    //                     <input
    //                         type="text"
    //                         className="text-filter"
    //                         key={"text-"+props.columnIdentifier}
    //                         onChange={ (e) => props.setFilter(props.columnIdentifier, e.target.value) }
    //                         placeholder={"Voornaam van de cursist"}
    //                         value={props.filterState?.[props.columnIdentifier] || ""} />
    //                 </>
    //             );
    //         }
    //     },
    //     {
    //         columnIdentifier: "student__last_name",
    //         type: "filter",
    //         Component: (props) => {
    //             return (
    //                 <>
    //                     <span>Cursist: achternaam</span>
    //                     <input
    //                         type="text"
    //                         className="text-filter"
    //                         key={"text-"+props.columnIdentifier}
    //                         onChange={ (e) => props.setFilter(props.columnIdentifier, e.target.value) }
    //                         placeholder={"Achternaam van de cursist"}
    //                         value={props.filterState?.[props.columnIdentifier] || ""} />
    //                 </>
    //             );
    //         }
    //     },
    //     {
    //         columnIdentifier: "student__email",
    //         type: "filter",
    //         Component: (props) => {
    //             return (
    //                 <>
    //                     <span>Cursist: e-mail</span>
    //
    //                     <input
    //                         type="text"
    //                         className="text-filter"
    //                         key={"text-"+props.columnIdentifier}
    //                         onChange={ (e) => props.setFilter(props.columnIdentifier, e.target.value) }
    //                         placeholder={"E-mailadres van de cursist"}
    //                         value={props.filterState?.[props.columnIdentifier] || ""} />
    //                 </>
    //             );
    //         }
    //     },
    //     {
    //         columnIdentifier: "student__nibhv_number",
    //         type: "filter",
    //         Component: (props) => {
    //             return (
    //                 <>
    //                     <span>Cursist: NIBHV#</span>
    //                     <input
    //                         type="text"
    //                         className="text-filter"
    //                         key={"text-"+props.columnIdentifier}
    //                         onChange={ (e) => props.setFilter(props.columnIdentifier, e.target.value) }
    //                         placeholder={"Het NIBHV-nummer van de cursist"}
    //                         value={props.filterState?.[props.columnIdentifier] || ""} />
    //                 </>
    //             );
    //         }
    //     },
    //     {
    //         columnIdentifier: "location",
    //         Component: props => {
    //             return (
    //                 <>
    //                     <span>Cursus: locatie</span>
    //                     <Filter
    //                         filterName={props.columnIdentifier}
    //                         filters={props.contextData?.locations || []}
    //                         noTitle={true}
    //                         key={props.columnIdentifier}
    //                         // className={cx("text-filter", props.className)}
    //                         type="dropdown"
    //                         compatibility={"new"}
    //                         placeholder={"Naam of postcode van de locatie"}
    //                         handleFilter={ (name, value) => props.setFilter(name, value || "") }
    //                         activeFilters={props.filterState || {}}
    //                         onChange={(e) => props.setFilter(props.columnIdentifier, e.target.value)}
    //                     />
    //
    //                 </>
    //             );
    //         }
    //     },
    // ],
    defaults: {
        ordering: {
            columnIdentifier: "your_reference",
            direction: ""
        },
        filter: {
            state: [constants.COURSE_STATE_OPEN],
            fields: "id,uuid,display_name,your_reference,course_datetime,state,trainer_details,students,expected_students"
        }
    }
};

export const CoursesOverviewDefinitionDefault = {
    ...CoursesOverviewDefinitionBase
};

export const CoursesOverviewDefinitionTrainer = {
    ...CoursesOverviewDefinitionBase
};

export const CourseOverviewDefinitionOverdue = {
    ...CoursesOverviewDefinitionBase,
    defaults: {
        ordering: {
            columnIdentifier: "date",
            direction: ""
        },
        filter: {
            ...CoursesOverviewDefinitionDefault.defaults.filter,
            preset: "overdue",
            state: [constants.COURSE_STATE_ENDED]
        }
    }
};

export const CourseOverviewDefinitionMissingInformation = {
    ...CoursesOverviewDefinitionBase,
    defaults: {
        ordering: {
            columnIdentifier: "date",
            direction: ""
        },
        filter: {
            ...CoursesOverviewDefinitionDefault.defaults.filter,
            preset: "missing-info",
            state: [constants.COURSE_STATE_OPEN]
        }
    }
};
